export const TEMPLATE_CATEGORIES = [
  { value: 'utility', label: 'Utility' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'authentication', label: 'Authentication' }
];

export const TEMPLATE_LANGUAGES = [
  { value: 'en', label: 'English' },
  { value: 'hi', label: 'Hindi' }
];

// Language-specific OTP button text for authentication templates.
// Add new language codes here to extend support.
export const AUTH_OTP_BUTTON_TEXTS = {
  en: 'Copy Code',
  hi: 'कोड कॉपी करें',
};

export const getAuthOtpButtonText = (langCode = 'en') => {
  return AUTH_OTP_BUTTON_TEXTS[langCode] || AUTH_OTP_BUTTON_TEXTS['en'];
};

export const AUTH_TEMPLATE_DEFAULTS = {
  messageSendTtlSeconds: 600,
  addSecurityRecommendation: false,
  codeExpirationMinutes: 10,
  otpType: 'copy_code',
  otpButtonText: getAuthOtpButtonText('en'),
};

export const REGULAR_TEMPLATE_DEFAULTS = {
  headerType: 'none',
  headerText: '',
};

export const getLanguageFriendlyName = (code) => {
  const map = {
    'en': 'English',
    'en_us': 'English (US)',
    'en_gb': 'English (UK)',
    'hi': 'Hindi',
    'es': 'Spanish',
    'pt_br': 'Portuguese (Brazil)',
    'fr': 'French',
    'de': 'German',
    'it': 'Italian',
    'ja': 'Japanese',
  };
  const cleanCode = (code || '').toLowerCase().replace('-', '_');
  return map[cleanCode] || code || 'Unknown';
};
